export enum InverterLossesType {
  TOTAL = 'losses_total',
  SWITCHING = 'losses_switching',
  CONDUCTION = 'losses_conduction',
  AC_HARNESS = 'losses_ac_harness',
  DC_HARNESS = 'losses_dc_harness',
  LOSSES = 'losses',
  TOTAL_LOSSES = 'losses_total',
  VOLTAGE_DROPS = 'voltage_drops',
}
